import axios from 'axios';

if (document)  {
	document.addEventListener('DOMContentLoaded', init);
}

function init() {
	const pardotForm = document.querySelector('[data-destination="pardot"]');
	console.log('pardot form', pardotForm)
	const apiUrl = 'api/forms/postToPardot';
	if (pardotForm) {
		document.addEventListener('rcGoodNowSubmit', e => {
			// e.preventDefault();
			const rcResponse = window.rcResponse;
			console.log('RECAPTCHA', rcResponse)
			const pardotId = pardotForm.dataset.pardot;
			if (typeof dataLayer != undefined) {
				dataLayer.push({
					event: 'genericEvent',
					eventCat: 'pardot form',
					eventAction: 'click',
					eventLabel: `submit attempt | ${pardotForm.id}`,
				});
			}
			handleFormSubmit(pardotForm, e, rcResponse, pardotId, apiUrl);
		});
	}
	if (localStorage) {
		const filledOutForm = localStorage.getItem('1850SelectSubmitted');
		const videoLead = document.querySelector('.video-lead');
		const blocker = document.querySelector('.blocker');
		const form = document.getElementById('1850-select-form');
		const postFormCopy = document.querySelector('.post-form__copy');
		const videoLeadCopy = document.querySelector('.post-form__v-lead-copy');
		const required = document.querySelector('.post-form__required');
		const app = document.querySelector('.app');
		const header = document.querySelector('.header--video');
		console.log('filled out form', filledOutForm);
		const explore = document.querySelector('.explore');
		const loader = document.querySelector('.loader');
		loader.style.display = 'none';
		if (filledOutForm) {
			console.log('filled out form');
			// form page
			if (videoLead) {
				videoLead.style.display = 'flex';
			}
			if (form) {
				form.style.display = 'none';
			}
			if (postFormCopy) {
				postFormCopy.style.display = 'none';
			}
			if (videoLeadCopy) {
				videoLeadCopy.style.display = 'block';
			}
			if (required) {
				required.style.display = 'none';
			}
			// video page
			if (blocker) {
				blocker.style.display = 'none';
			}
			if (app) {
				app.style.display = 'block';
			}
			if (header) {
				header.style.display = 'block';
			}
			if (explore) {
				explore.style.display = 'flex';
			}
		} else {
			console.log('not filled out form');
			// video page
			if (blocker) {
				blocker.style.display = 'flex';
			}
			if (app) {
				app.style.display = 'none';
			}
			if (header) {
				header.style.display = 'none';
			}
			// form page
			if (postFormCopy) {
				postFormCopy.style.display = 'block';
			}
			console.log('form', form);
			if (form) {
				form.style.display = 'block';
			}
			if (required) {
				required.style.display = 'block';
			}
		}
	}
}

function handleFormSubmit(form, event, rcResponse, pardotId, apiUrl) {
	console.log('form for submit', form);
	console.log('response', rcResponse);
	const { elements } = form;
	const myFormData = new FormData();
	let button = form.querySelector('button[type="submit"]');

	for (let i = 0; i < elements.length; i += 1) {
		if (
			elements[i].value !== '' &&
			elements[i].name !== '' &&
			elements[i].type !== 'radio' &&
			elements[i].type !== 'submit' &&
			elements[i].type !== 'checkbox'
		) {
			myFormData.append(elements[i].name, elements[i].value);
		} else if (elements[i].type === 'checkbox') {
			if (elements[i].checked === true) {
				myFormData.append(elements[i].name, 'yes');
			} else {
				myFormData.append(elements[i].name, 'no');
			}
		}
	} // end for loop

	//   // console.log('form elements', myFormData);
	//   // console.log('apiUrl', apiUrl);
	if (button) {
		button.innerHTML = `<span>Sending...</span>`;
	}

	myFormData.append(
		'pardot_url',
		`http://go.smuckerawayfromhome.com/l/555762/${pardotId}`
	);
	myFormData.append('response', rcResponse);

	console.log('myFormData', myFormData);

	axios({
		method: 'post',
		url: apiUrl,
		data: myFormData,
		config: {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'cache-control': 'no-cache',
			},
		},
	})
		.then(response => {
			console.log(response);
			if (response.data.indexOf('error') > 0) {
				console.error('error response data', response.data);
				if (button) {
					button.innerHTML = `<span>Error</span>`;
				}
				if (typeof dataLayer === 'object') {
					dataLayer.push({
						event: 'genericEvent',
						eventCat: 'pardot form',
						eventAction: 'error',
						eventLabel: `${response.data} | ${form.id}`,
					});
				}
			} else if (response.data.indexOf('ReCaptcha Fail') > 0) {
				if (button) {
					button.innerHTML = `<span>Error</span>`;
				}
				if (typeof dataLayer === 'object') {
					dataLayer.push({
						event: 'genericEvent',
						eventCat: 'pardot form',
						eventAction: 'error',
						eventLabel: `${response.data} | ${form.id}`,
					});
				}
				console.error('error response data', response.data);
				return;
			} else if (response.status === 200) {
				if (button) {
					button.innerHTML = `<span>Sent</span>`;
					button.disabled = true;
				}
				if (localStorage) {
					localStorage.setItem('1850SelectSubmitted', 'true');
				}
				// redirect to the thank you page
				window.location.href = '/Campaigns/1850-select-brew-video';
				if (typeof dataLayer === 'object') {
					dataLayer.push({
						event: 'genericEvent',
						eventCat: 'pardot form',
						eventAction: 'success',
						eventLabel: form.id,
					});
				}
			}
		})
}